import React, { useState } from "react";
import axios from "axios";

function App() {
  const [city, setCity]   = useState('');
  const [weather, setWeather] = useState(null);
  const [recent, setRecent] = useState(() => {
  const saved = localStorage.getItem("recentCities");
  return saved ? JSON.parse(saved) : [];
});

  const getWeather = async () => {
    if (!city) return;
    const apiKey = process.env.REACT_APP_WEATHER_API_KEY;
    const url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;

    try {
      const response = await axios.get(url);
      setWeather(response.data);
setRecent(prev => {
  const updated = [city, ...prev.filter(c => c !== city)];
  const trimmed = updated.slice(0, 5);
  localStorage.setItem("recentCities", JSON.stringify(trimmed));
  return trimmed;
});

    } catch (err) {
      alert("City not found or something went wrong!");
      console.error(err);
    }
  };

  // 🔥 NEW helper to choose background colour
  const getBackgroundClass = () => {
    if (!weather) return "bg-blue-400";
    const condition = weather.weather[0].main;
    switch (condition) {
      case "Clear":        return "bg-yellow-300";
      case "Clouds":       return "bg-gray-400";
      case "Rain":
      case "Drizzle":      return "bg-blue-700";
      case "Thunderstorm": return "bg-purple-800";
      case "Snow":         return "bg-blue-200";
      case "Mist":
      case "Fog":          return "bg-gray-500";
      default:             return "bg-blue-400";
    }
  };

  return (
    <div
      className={`min-h-screen flex flex-col items-center justify-center text-white p-4 transition-all duration-500 ${getBackgroundClass()}`}
    >
      <h1 className="text-4xl font-bold mb-6">🌤 Weather App</h1>

      <input
        type="text"
        value={city}
        onChange={(e) => setCity(e.target.value)}
        placeholder="Enter city"
        className="p-2 rounded text-black w-60 mb-4"
      />

      <button
        onClick={getWeather}
        className="bg-white text-blue-700 px-4 py-2 rounded font-bold"
      >
        Get Weather
      </button>
        {recent.length > 0 && (
  <div className="flex flex-wrap gap-2 mt-4">
    {recent.map(rc => (
      <button
        key={rc}
        onClick={() => {
          setCity(rc);
          getWeather();
        }}
        className="bg-white/80 text-blue-800 px-3 py-1 rounded-full text-sm hover:bg-white"
      >
        {rc}
      </button>
    ))}
  </div>
)}

      {weather && (
        <div className="bg-white text-blue-900 mt-6 p-6 rounded-xl shadow-xl w-full max-w-md text-center">
          <h2 className="text-3xl font-bold">{weather.name}</h2>

          <div className="flex flex-col items-center mt-4">
            <img
              src={`http://openweathermap.org/img/wn/${weather.weather[0].icon}@2x.png`}
              alt="weather icon"
              className="w-24 h-24"
            />
            <p className="text-xl capitalize mt-2">
              {weather.weather[0].description}
            </p>
          </div>

          <p className="text-4xl font-semibold mt-4">
            {weather.main.temp}°C
          </p>

          <div className="mt-4 space-y-1 text-sm">
            <p>🌡 Feels Like: {weather.main.feels_like}°C</p>
            <p>💧 Humidity: {weather.main.humidity}%</p>
            <p>🌬 Wind Speed: {weather.wind.speed} m/s</p>
            <p>
              🔻 Min: {weather.main.temp_min}°C | 🔺 Max: {weather.main.temp_max}°C
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
